// ─────────────────────────────────────────────────────────────
// src/utils/translations.js
// Static translation map. Pure data – no logic, no React.
// ─────────────────────────────────────────────────────────────

const translations = {
  en: {
    salaryCalculator: "Salary Calculator",
    individualCalculator: "Individual Calculator",
    individualDesc: "Calculate salary for one employee at a time",
    bulkExcelProcessor: "Bulk Excel Processor",
    bulkDesc: "Process multiple employees from Excel files",
    selectCalculationType: "Select Calculation Type",
    calculateNetFromGross: "Calculate Net from Gross",
    netFromGrossDesc: "Enter gross salary and insurance salary",
    netFromGrossExcelDesc: "Upload: Employee Name, Insurance Salary, Gross Salary",
    calculateGrossFromNet: "Calculate Gross from Net",
    grossFromNetDesc: "Enter net salary and insurance salary",
    grossFromNetExcelDesc: "Upload: Employee Name, Insurance Salary, Net Salary",
    insuranceSalary: "Insurance Salary",
    insuranceSalaryRequired: "Insurance Salary (Required)",
    insuranceSalaryError: "Insurance salary is required",
    grossSalary: "Gross Salary",
    grossSalaryError: "Gross salary is required",
    netSalary: "Net Salary",
    netSalaryError: "Net salary is required",
    calculateNow: "Calculate Now",
    reset: "Reset",
    calculationResults: "Calculation Results",
    monthlyTax: "Monthly Tax",
    martyrsFund: "Martyrs Fund (0.0005%)",
    deductionDetails: "Deduction Details",
    employeeInsuranceShare: "Employee Insurance Share (11%)",
    monthlyIncomeTax: "Monthly Income Tax",
    yearlyTax: "Yearly Tax",
    totalDeductions: "Total Deductions",
    note: "Note",
    noteText:
      "These calculations are based on Egyptian tax law. The annual exemption is 20,000 EGP, and progressive tax rates apply from 10% to 27.5% based on income brackets.",
    uploadExcelFile: "Upload Excel File",
    clickToUpload: "Click to upload or drag and drop",
    excelFilesOnly: "Excel files (.xlsx, .xls) only",
    processExcel: "Process Excel",
    processing: "Processing...",
    downloadResults: "Download Results",
    successfullyProcessed: "Successfully processed",
    employeeRecords: "employee records!",
    resultsPreview: "Results Preview",
    records: "records",
    employeeName: "Employee Name",
    showingFirst: "Showing first 10 of",
    recordsDownload: "records. Download to see all.",
    egp: "EGP",
    enterGrossSalary: "Enter gross salary",
    enterNetSalary: "Enter net salary",
    enterInsuranceSalary: "Enter insurance salary",
    pleaseUploadFile: "Please upload a file first",
    excelFileEmpty: "Excel file is empty",
    invalidDataInRow: "Invalid data in row",
    noValidData: "No valid data to process",
    errorProcessingFile: "Error processing file",
  },
  ar: {
    salaryCalculator: "حاسبة الرواتب",
    individualCalculator: "حاسبة فردية",
    individualDesc: "احسب راتب موظف واحد في كل مرة",
    bulkExcelProcessor: "معالجة إكسل جماعية",
    bulkDesc: "معالجة رواتب عدة موظفين من ملفات إكسل",
    selectCalculationType: "اختر نوع الحساب",
    calculateNetFromGross: "احسب الصافي من الإجمالي",
    netFromGrossDesc: "أدخل الراتب الإجمالي وراتب التأمينات",
    netFromGrossExcelDesc: "تحميل: اسم الموظف، راتب التأمينات، الراتب الإجمالي",
    calculateGrossFromNet: "احسب الإجمالي من الصافي",
    grossFromNetDesc: "أدخل الراتب الصافي وراتب التأمينات",
    grossFromNetExcelDesc: "تحميل: اسم الموظف، راتب التأمينات، الراتب الصافي",
    insuranceSalary: "راتب التأمينات",
    insuranceSalaryRequired: "راتب التأمينات (مطلوب)",
    insuranceSalaryError: "راتب التأمينات مطلوب",
    grossSalary: "الراتب الإجمالي",
    grossSalaryError: "الراتب الإجمالي مطلوب",
    netSalary: "الراتب الصافي",
    netSalaryError: "الراتب الصافي مطلوب",
    calculateNow: "احسب الآن",
    reset: "إعادة تعيين",
    calculationResults: "نتائج الحساب",
    monthlyTax: "الضريبة الشهرية",
    martyrsFund: "صندوق الشهداء (0.0005%)",
    deductionDetails: "تفاصيل الخصومات",
    employeeInsuranceShare: "حصة الموظف في التأمينات (11%)",
    monthlyIncomeTax: "ضريبة الدخل الشهرية",
    yearlyTax: "الضريبة السنوية",
    totalDeductions: "إجمالي الخصومات",
    note: "ملاحظة",
    noteText:
      "هذه الحسابات مبنية على قانون الضرائب المصري. الإعفاء السنوي هو 20,000 جنيه، وتطبق معدلات ضريبية تصاعدية من 10% إلى 27.5% حسب شرائح الدخل.",
    uploadExcelFile: "تحميل ملف إكسل",
    clickToUpload: "انقر للتحميل أو اسحب وأفلت",
    excelFilesOnly: "ملفات إكسل فقط (.xlsx, .xls)",
    processExcel: "معالجة الإكسل",
    processing: "جاري المعالجة...",
    downloadResults: "تحميل النتائج",
    successfullyProcessed: "تمت معالجة",
    employeeRecords: "سجل موظف بنجاح!",
    resultsPreview: "معاينة النتائج",
    records: "سجل",
    employeeName: "اسم الموظف",
    showingFirst: "عرض أول 10 من",
    recordsDownload: "سجل. قم بالتحميل لرؤية الكل.",
    egp: "ج.م",
    enterGrossSalary: "أدخل الراتب الإجمالي",
    enterNetSalary: "أدخل الراتب الصافي",
    enterInsuranceSalary: "أدخل راتب التأمينات",
    pleaseUploadFile: "الرجاء تحميل ملف أولاً",
    excelFileEmpty: "ملف الإكسل فارغ",
    invalidDataInRow: "بيانات غير صحيحة في الصف",
    noValidData: "لا توجد بيانات صحيحة للمعالجة",
    errorProcessingFile: "خطأ في معالجة الملف",
  },
};

export default translations;